import { VpnPriceComparisonWrapper } from "@components/layouts";
import CheckIcon from "@components/svg/checkIcon";
import { vpnFeatures } from "@lib/vpnpricecomparison/vpnFeatures";
import React, { ReactElement } from "react";
import Listing from "../listing";
import colors from "@styles/variables/vpnpricecomparisonVariables.module.scss";
import { useDomainContext } from "@hooks/useDomainContext";
import { affiliateOfferZones } from "@lib/shared/config";

type Props =
    | {
          type: "listing";
          comparison?: boolean;
      }
    | {
          type: "comparison";
          comparison: boolean;
      };

export default function ListingPage(props: Props): ReactElement {
    const { type } = props;

    const { visitDetails, comparisonListing, categoryListing, formattedTitle } =
        useDomainContext();

    return (
        <VpnPriceComparisonWrapper
            backgroundColor={
                categoryListing?.hiddenAttributes?.color ?? "#FFAC00"
            }
            withFlag={type === "comparison"}
        >
            <div className="details">
                <div className="flex flex-col md:flex-row flex-wrap lg:justify-between lg:items-center mb-10">
                    <div className="md:w-1/2">
                        <h1
                            className="text-xl md:text-2xl lg:text-3xl font-bold"
                            dangerouslySetInnerHTML={{
                                __html:
                                    type === "listing"
                                        ? categoryListing?.pageTitle ?? ""
                                        : formattedTitle ??
                                          `Best VPN Companies For ${visitDetails?.country}`,
                            }}
                        ></h1>
                        {type === "listing" ? (
                            <ul className="text-sm md:text-sm mt-3">
                                {categoryListing?.features.map(
                                    (feature, index) => (
                                        <li
                                            className="flex font-light items-start mb-2 "
                                            style={{ color: colors.melon }}
                                            key={index}
                                        >
                                            <CheckIcon className="w-3 h-3 mr-2 mt-1.5 fill-current" />
                                            <span
                                                style={{
                                                    color: colors.slightlyBlack,
                                                }}
                                            >
                                                {feature}
                                            </span>
                                        </li>
                                    ),
                                )}
                            </ul>
                        ) : (
                            <p className="text-sm md:text-base font-light mt-4">
                                For Limited Time, We Managed to Secure Exclusive
                                Offers &amp; Deals For the Top VPN Providers.
                                Act Now, Here are the Best Available Deals:
                            </p>
                        )}
                    </div>
                </div>
                <Listing
                    zone={
                        type === "listing"
                            ? affiliateOfferZones.LISTING_PAGE
                            : affiliateOfferZones.COMPARISON_PAGE
                    }
                    listing={
                        type === "listing"
                            ? categoryListing?.offers
                            : comparisonListing?.offers
                    }
                />
                <div className="features horizontal-scroll lg:overflow-auto mt-7 h-40 lg:h-56 -m-4 lg:m-0 px-4 lg:px-0 lg:mt-6">
                    {vpnFeatures.map((feature, index) => (
                        <div
                            key={index}
                            style={{ borderColor: colors.pinkishGrey }}
                            className="border text-center horizontal-scroll-child lg:flex-auto flex flex-col justify-center items-center w-4/5 md:w-2/5 mr-4 last:mr-0 py-5 lg:px-4"
                        >
                            <span className="children:w-10 children:h-10">
                                {feature.icon}
                            </span>
                            <h3 className="mt-5 text-sm lg:text-base w-full">
                                {feature.title}
                            </h3>
                        </div>
                    ))}
                </div>
            </div>
        </VpnPriceComparisonWrapper>
    );
}
